module.exports = __webpack_public_path__ + "static/img/2wv1.1a6ef93a.png";